import UsePermissionsClaim from "./UsePermissionsClaim";

const useSidebarPermissions = () => {
  const { checkPermission } = UsePermissionsClaim();

  const checkExpenseHistory =
    checkPermission("sup_check") ||
    checkPermission("admin_check") ||
    checkPermission("sup_admin_check");

  const subMenuPermMap = {
    view_user: checkPermission("view_user"),
    add_user: checkPermission("add_user"),
    add_officer: checkPermission("add_officer"),
    view_officer: checkPermission("add_officer"),
    update_user: checkPermission("update_user"),
    add_expense: checkPermission("add_expense"),
    view_receiver_rejected_company_expense: checkPermission(
      "view_receiver_rejected_company_expense",
    ),
    sup_check: checkPermission("sup_check"),
    admin_check: checkPermission("admin_check"),
    sup_admin_check: checkPermission("sup_admin_check"),
    add_loan: checkPermission("add_loan"),
    add_deduction_expense: checkPermission("add_deduction_expense"),
    view_complaint: checkPermission("view_complaint"),
    add_complaint: checkPermission("add_complaint"),
    add_visit: checkPermission("add_visit"),
    resolve_complaint: checkPermission("resolve_complaint"),
    check_visit: checkPermission("check_visit"),
    view_visit: checkPermission("view_visit"),
    view_site: checkPermission("view_site"),
    add_site: checkPermission("add_site"),
    add_machine: checkPermission("add_machine"),
    assign_machine: checkPermission("add_machine"),
    add_hier: checkPermission("add_hier"),
    add_sheets: checkPermission("add_sheets"),
    station_repair: checkPermission("station_repair_work_done"),
    view_sheets: checkPermission("view_sheets"),
    view_generated_sheets: checkPermission("view_generated_sheets"),
    view_machine: checkPermission("view_machine"),
    add_machine_component: checkPermission("add_machine_component"),
    add_loan_expense: checkPermission("add_loan_expense"),
    check_history: checkExpenseHistory,
    register_cylinder: checkPermission("register_cylinder"),
    view_cylinder: checkPermission("view_cylinder"),
    dispatch_cylinder: checkPermission("dispatch_cylinder"),
    receive_cylinder: checkPermission("receive_cylinder"),
    add_vehicle: checkPermission("add_vehicle"),
    add_job_card: checkPermission("checkpoint_access"),
    job_card_history: checkPermission("job_card_history"),
    add_overtime: checkPermission("payroll_addition"),
    disable_user: checkPermission("disable_user"),
    users_logs: checkPermission("access_token_logs"),
    cylinder_prediction: checkPermission("station_average_cylinder_prediction"),
    checkpoint_inform: checkPermission("job_card_reviewer"),
    discarded_cylinders: checkPermission("view_discarded_cylinder"),
    add_vehicle_reading: checkPermission("add_vehicle_log"),
    all_vehicle_readings: checkPermission("view_vehicle_log"),
    pending_vehicle_readings: checkPermission("check_vehicle_log"),
    add_material_transport: checkPermission("add_material_transport"),
    view_material_transport: checkPermission("view_material_transport"),
  };

  const permViewUser = checkPermission("view_user");
  const permAddUser = checkPermission("add_user");
  const permAddOfficer = checkPermission("add_officer");
  const permViewComplaint = checkPermission("view_complaint");
  const permAddComplaint = checkPermission("add_complaint");
  const permCheckComplaint = checkPermission("resolve_complaint");
  const permCheckVisit = checkPermission("check_visit");
  const permAddSite = checkPermission("add_site");
  const permViewSite = checkPermission("view_site");
  const permAddMachine = checkPermission("add_machine");
  const permAddHier = checkPermission("add_hier");
  const permAddSheets = checkPermission("add_sheets");
  const permViewSheets = checkPermission("view_sheets");
  const permViewMachines = checkPermission("view_machine");
  const permAddMachineComp = checkPermission("add_machine_component");
  const permRegisteredCylinder = checkPermission("register_cylinder");
  const permViewCylinder = checkPermission("view_cylinder");
  const permDispatchCylinder = checkPermission("dispatch_cylinder");
  const permResetPassword = checkPermission("update_password");
  const permJobCard = checkPermission("checkpoint_access");
  const permDisableUser = checkPermission("disable_user");
  const ViewGeneratedSheet = checkPermission("view_generated_sheets");

  const mainMenuPermMap = {
    user:
      permViewUser ||
      permAddUser ||
      permAddOfficer ||
      permDisableUser ||
      subMenuPermMap.users_logs ||
      subMenuPermMap.update_user,
    maintenance:
      permAddComplaint ||
      permViewComplaint ||
      permCheckComplaint ||
      permCheckVisit ||
      subMenuPermMap.add_vehicle_reading ||
      subMenuPermMap.all_vehicle_readings ||
      subMenuPermMap.pending_vehicle_readings ||
      permViewSite ||
      subMenuPermMap.station_repair ||
      subMenuPermMap.add_material_transport ||
      subMenuPermMap.view_material_transport,
    expense_sheet: permViewSheets || permAddSheets || ViewGeneratedSheet,
    site_manager:
      permAddSite ||
      permViewSite ||
      permAddMachine ||
      permAddHier ||
      permViewMachines ||
      permAddMachineComp,
    cylinder_tracking:
      permRegisteredCylinder ||
      permViewCylinder ||
      permDispatchCylinder ||
      subMenuPermMap.cylinder_prediction ||
      subMenuPermMap.discarded_cylinders,
    reset_password: permResetPassword,
    factory: permJobCard || subMenuPermMap.checkpoint_inform,
  };

  return { subMenuPermMap, mainMenuPermMap };
};

export default useSidebarPermissions;
